import { Component } from '@angular/core';
import { Room } from 'src/sync/room';
import { L } from 'src/sync/_api';
import { WatchAwareComponent } from 'src/app/watch-aware.component';

@Component({
    selector: 'app-control-fog',
    templateUrl: './control-fog.component.html',
    styleUrls: ['./control-fog.component.scss'],
    standalone: false
})
export class ControlFogComponent extends WatchAwareComponent {
    public color!: string;

    public ngOnInit() {
        const getColor = () => {
            this.color = Room.layers.get(L.Fog).fillColor;
            this.changeDetectorRef.detectChanges();
        }

        getColor();
        Room.layers.watch((id) => {
            if (id == L.Fog) getColor();
        });
    }

    public update() {
        Room.layers.modify(L.Fog, x => {
            x.fillColor = this.color;
        });
    }
}
